<template>
	<div>
			<!-- <b-row>
				<b-col cols="12" class="mt-4">
					<b-row>
						<b-col cols="12" md="6" lg="3">
							<base-select class="d-inline-block w-100" v-model="selectedCategory" :label="$i18nHelpers.normalizeProp('name')" :options="allCategories" :placeholder="$t('patient.microhabits.select-category')"/>
						</b-col>
						<b-col cols="12" md="6" lg="3" class="my-auto">
							<div class="pt-3 pt-md-0">
								<b-form-checkbox v-model="showOnlyInDiet" switch class="d-inline-block ml-3">
									{{$t('patient.microhabits.show-only-in-diet')}}
								</b-form-checkbox>
							</div>
						</b-col>
					</b-row>
				</b-col> 
			</b-row> -->
			<div v-if="filteredPatientMicrohabits.length > 0">
				<transition-group name="list" tag="div" class="row neu-cards-ctn landing-cnt mt-5 row-cols-1 row-cols-xl-4">
					<!-- <PatientMicrohabitBlock v-for="patientMicrohabit in filteredPatientMicrohabits" :key="patientMicrohabit.id" :patientMicrohabit="patientMicrohabit" :categories="[patientMicrohabit.microhabitCategory]"/> -->
					<!-- Used in case we want unique microhabit blocks and not one by category (avoiding duplicates)-->
				<PatientMicrohabitBlock v-for="patientMicrohabit in uniquePatientMicrohabitsSorted" :key="patientMicrohabit.id" :patientMicrohabit="patientMicrohabit" :categories="getAllSavedCategories(patientMicrohabit)" noBackgroundImage :type="type" showHeartIcon @deleted="loadPatientMicrohabits" :img="patientMicrohabit.microhabit.icon || DEFAULT_MICROHABIT_IMAGE"/>
				</transition-group>
			</div>
			<b-row v-if="!patientMicrohabits || patientMicrohabits.length === 0" class="landing-cnt mt-4" cols="12">
					<b-col cols="12">
						<b-alert show variant="secondary">{{ $t('patient.microhabits.no-microhabits', { typeName: microhabitI18nName({ plural: false }) }) }}<br><base-button class="mt-4" variant="primary" @click="$router.push('/patient/microhabits')">{{ $t('patient.microhabits.add-microhabit', { typeName: microhabitI18nName({ plural: true }) })}}</base-button></b-alert>
					</b-col>
			</b-row>
			<div v-if="patientMicrohabits && patientMicrohabits.length > 0 && filteredPatientMicrohabits.length === 0" class="landing-cnt w-100 mt-4">
				<b-alert show variant="secondary">{{ $t('patient.microhabits.no-microhabits-with-filters', { typeName: microhabitI18nName({ plural: true }) })}}</b-alert>
			</div>
	</div>
</template>

<script>
import PatientMicrohabitBlock from './PatientMicrohabitBlock'
import { BFormCheckbox, BAlert } from 'bootstrap-vue'
import BaseSelect from '@/components/base/forms/BaseSelect'
import Velocity from 'velocity-animate'
import microhabitsMixin from '@/mixins/microhabits.mixin'

export default {
	mixins: [microhabitsMixin],
	components: {
		PatientMicrohabitBlock,
		BFormCheckbox,
		BaseSelect,
		BAlert
	},
	data () {
		return {
			patientMicrohabits: [],
			uniquePatientMicrohabits: [],
			showOnlyAchieved: false,
			selectedCategory: null
		}
	},
	computed: {
		// (Used in case we only want to show the unique microhabits, not one by category)
		uniquePatientMicrohabitsSorted () {
			return this.uniquePatientMicrohabits.sort((a, b) => this.$i18nHelpers.normalize(a.microhabit.name).localeCompare(this.$i18nHelpers.normalize(b.microhabit.name)))
		},
		filteredPatientMicrohabits () {
			let filteredPatientMicrohabits = this.patientMicrohabits

			if (this.showOnlyAchieved) {
				filteredPatientMicrohabits = filteredPatientMicrohabits.filter((pf) => pf.inDiet)
			}

			if (this.selectedCategory) {
				filteredPatientMicrohabits = filteredPatientMicrohabits.filter((pf) => pf.microhabitCategory.id === this.selectedCategory)
			}

			// Sort alphabetically by microhabit name
			return filteredPatientMicrohabits.sort((a, b) => this.$i18nHelpers.normalize(a.microhabit.name).localeCompare(this.$i18nHelpers.normalize(b.microhabit.name)))
		},
		allCategories () {
			// Unique categories from patientMicrohabits
			return this.patientMicrohabits.map((pf) => pf.microhabitCategory).filter((category, index, self) => self.findIndex((c) => c.id === category.id) === index)
		}
	},
	methods: {
		loadPatientMicrohabits () {
			this.microhabitRepository.getPatientMicrohabits().then((response) => {
				this.patientMicrohabits = response.data
				// Delete microhabits with same id and get an array
				this.uniquePatientMicrohabits = response.data.filter((patientMicrohabit, index, self) => self.findIndex((pf) => pf.microhabit.id === patientMicrohabit.microhabit.id) === index)
			})
		},
		getAllSavedCategories (patientMicrohabit) {
			let categories = []
			this.patientMicrohabits.forEach((pf) => {
				if (pf.microhabit.id === patientMicrohabit.microhabit.id) {
					categories.push(pf.microhabitCategory)
				}
			})
			return categories
		},
		beforeEnter (el) {
      el.style.opacity = 0
      el.style.width = 0
    },
    enter (el, done) {
      Velocity(el, { opacity: 1, width: '1.6em' }, { complete: done })
    },
    leave (el, done) {
      Velocity(el, { opacity: 0, width: 0 }, { complete: done })
    },
    beforeLeave (el) {
      el.style.position = 'absolute'
    },
		move (el, done) {
			const offset = el.offsetWidth
			el.style.transform = `translateX(${offset}px)`
			Velocity(el, { transform: 'translateY(0)' }, { complete: done })
		}
	},
	mounted () {
		this.loadPatientMicrohabits()
	}
}
</script>

<style lang="scss">
@import "/node_modules/@asika32764/vue-animate/dist/vue-animate.css";
/* .card-enter-active, .card-leave-active {
  transition: transform 0.5s, opacity 0.5s;
}

.card-enter, .card-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.card-enter-to, .card-leave {
  transform: translateX(0);
  opacity: 1;
} */

/* .list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
} */

.list-enter-active, .list-leave-active {
  transition: opacity 0.5s;
}

.list-enter, .list-leave-to {
  opacity: 0;
}

.list-enter-to, .list-leave {
  opacity: 1;
}

.list-move {
	transition: all 1s;
}

</style>


// WEBPACK FOOTER //
// src/components/microhabits/PatientMicrohabitsPanelMenu.vue